import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
  templateUrl: './colorbox-fetch.component.html',
  styleUrls: ['./colorbox-fetch.component.less']
})
export class ColorboxFetchComponent implements OnInit {

  @Input()
  public Title: string = null;

  @Input()
  public CloseText: string = 'Close';

  @Input()
  public Href: URL;

  @Output()
  public OnClose: EventEmitter<void> = new EventEmitter();
  
  public Content$: Observable<any>;

  constructor(
    public modal: BsModalRef,
    private http: HttpClient,
    @Inject(DOCUMENT) private document: Document,
    ) {
  }

  public ngOnInit(): void {
    this.Content$ = this.http.get(this.Href.toString(), { responseType: 'text' }).pipe(
      map(response => {
        const doc = document.implementation.createHTMLDocument(this.Title);
        doc.documentElement.innerHTML = response;
        this.Title = doc.title.split('|')[0].trim();
        const main = doc.querySelector('.block.block-system.block-system-main-block');
        if (main) {
          return main.innerHTML;
        }
      })
    );
  }

  public Close(): void {
    this.OnClose.emit();
    this.modal.hide();
  }

}
